import React from 'react';
import { Card } from 'primereact/card';

export default function TrucksPage() {
  const trucks = [
    { id: 'TR-001', model: 'Mixer 3000', status: 'Online' },
    { id: 'TR-002', model: 'Mixer 2000', status: 'Offline' },
    { id: 'TR-003', model: 'Tipper X', status: 'Online' }
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginTop: 0 }}>Trucks</h2>
      <Card className="cyber-card">
        {trucks.map(t => (
          <div key={t.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
            <div><strong>{t.id}</strong> - {t.model}</div>
            <div style={{ opacity: 0.8 }}>{t.status}</div>
          </div>
        ))}
      </Card>
    </div>
  );
}